{
  "fr": {
    "classroomScreen": {
      "buttons": {
        "annotate": "Dessiner",
        "cardActions": "Actions de la carte",
        "clearAllDrawings": "Supprimer tous les dessins",
        "eraser": "Gomme",
        "pencil": "Stylo",
        "marker": "Marqueur",
        "continue": "Continuer",
        "createQrCode": "Créer un QR code",
        "customTime": "Autre minuteur",
        "delete": "Supprimer",
        "deleteCard": "Supprimer la carte",
        "drawTicket": "Tirer un nouveau lot",
        "duplicate": "Dupliquer",
        "embed": "Intégrer",
        "fifteenMinutes": "15 minutes",
        "fiveMinutes": "5 minutes",
        "green": "Feu vert",
        "groupMode": "Travail de groupe",
        "groupShuffle": "Mélanger les groupes",
        "insertTool": "Intégrer l'outil",
        "moveToPage": "Page {page}",
        "partnerMode": "Travail en binôme",
        "pause": "Pause",
        "plenumMode": "Plénière",
        "red": "Feu rouge",
        "reset": "Réinitialiser",
        "resetTickets": "Remettre tous les lots dans le pot",
        "rollDice": "Lancer le dé",
        "showVideo": "Afficher la vidéo",
        "silenceMode": "Travail individuel",
        "start": "Démarrer",
        "stop": "Arrêter",
        "submitList": "Mettre les lots dans le pot",
        "tenMinutes": "10 minutes",
        "uploadFile": "Télécharger un fichier",
        "viewInSpotlight": "Ouvrir la carte en mode projecteur",
        "yellow": "Feu jaune"
      },
      "components": {
        "dice": "Dé",
        "embed": "Intégrer",
        "file": "Fichier",
        "group": "Groupe",
        "image": "Image",
        "internalTool": "Outil",
        "lottery": "Pot à lots",
        "qrcode": "Lien",
        "stoplights": "Feu tricolore",
        "stopwatch": "Chronomètre",
        "text": "Texte",
        "timer": "Minuteur",
        "video": "Vidéo",
        "watch": "Horloge",
        "workMode": "Forme sociale"
      },
      "confirm": {
        "deleteCard": {
          "title": "Supprimer la carte ?",
          "text": "Cette action est irréversible. Tout le contenu de la carte actuelle sera définitivement supprimé."
        },
        "deletePage": {
          "title": "Supprimer la page actuelle ?",
          "text": "Cette action est irréversible. Tout le contenu de la page actuelle sera définitivement supprimé."
        },
        "clearCanvas": {
          "title": "Supprimer tous les dessins ?",
          "text": "Cette action est irréversible. Tous les dessins de la page actuelle seront définitivement supprimés."
        }
      },
      "flash": {
        "pageAdded": "Nouvelle page ajoutée",
        "pageDeleted": "Page supprimée",
        "pageUpdated": "Page mise à jour",
        "cardUpdateFailed": "La modification n'a pas pu être enregistrée",
        "cardDeleteFailed": "La carte n'a pas pu être supprimée",
        "cardCreateFailed": "La carte n'a pas pu être créée",
        "pageCreateFailed": "La page n'a pas pu être créée",
        "pageDeleteFailed": "La page n'a pas pu être supprimée",
        "pageReorderFailed": "L'ordre n'a pas pu être enregistré",
        "canvasSaveFailed": "Le dessin n'a pas pu être enregistré",
        "saving": "Enregistrement…"
      },
      "headings": {
        "classroomScreen": "Tableau numérique",
        "group": "Groupe",
        "minScreenWidth": "Veuillez ouvrir le Tableau numérique sur une tablette ou un ordinateur portable"
      },
      "hints": {
        "embedCard": "Utilisez le module d'outils pour intégrer les outils fobizz. Ainsi, lors de la copie de cette unité d'enseignement, une version propre des matériaux intégrés sera automatiquement créée.",
        "itemId": "Assurez-vous de partager les contenus avec d'autres pour qu'ils puissent être correctement affichés.",
        "itemType": "Si vous copiez ce tableau, une nouvelle version de tous les contenus intégrés ici sera automatiquement créée. Vous pouvez ainsi facilement utiliser une unité d'enseignement existante pour un autre public cible.",
        "maxLengthTitle": "Le titre est limité à 45 caractères maximum.",
        "minScreenWidth": "Pour voir le Tableau numérique, vous avez besoin d'une résolution d'au moins <strong>768&nbsp;pixels</strong> de largeur.",
        "noTicketsLeft": "Le pot est vide !"
      },
      "labels": {
        "diceCount": "Nombre de dés",
        "embed": "URL ou extrait Iframe",
        "embedInternal": "Afficher l'aperçu",
        "groupCount": "Nombre de groupes",
        "groupMode": "Travail de groupe",
        "groupSize": "Taille du groupe",
        "itemId": "Titre",
        "itemType": "Outil",
        "minutes": "Minutes",
        "partnerMode": "Travail en binôme",
        "plenumMode": "Plénière",
        "qrcodeInternal": "Intégrer le QR code",
        "seconds": "Secondes",
        "shuffleCondition": "Condition pour le mélange des groupes",
        "silenceMode": "Travail individuel",
        "start": "Démarrer",
        "title": "Titre pour votre carte",
        "continue": "Reprendre",
        "pause": "Pause"
      },
      "placeholders": {
        "enterItems": "Une entrée par ligne, par exemple :\nMax\nMoritz",
        "enterText": "Saisir le texte…",
        "enterUrl": "Saisir l'URL…",
        "enterUrlOrSnippet": "Saisir l'URL ou l'extrait iFrame…",
        "enterVideoUrl": "Saisir l'URL YouTube ou Vimeo…",
        "names": "Un nom par ligne, par exemple :\nMax\nMoritz",
        "title": "Titre...",
        "typeName": "Saisir le nom"
      },
      "validations": {
        "itemLocked": "Ce contenu est configuré pour que seul l'auteur puisse le voir. Veuillez le contacter pour modifier cela."
      },
      "tooltips": {
        "editMode": "Modifier",
        "drawMode": "Dessiner"
      },
      "viewModes": {
        "tool": "Mode outil",
        "canvas": "Mode dessin"
      }
    },
    "schoolClass": {
      "classroom": {
        "labels": {
          "activateControls": {
            "stop": "Arrêter"
          }
        }
      }
    }
  }
}
